const EmptyData = ({ children, className }) => {
  return (
    <>
      <div
        className={`w-full text-equidia-blue text-center rounded border border-blue-200 text-sm p-3 px-4 bg-blue-100 ${className}`}
      >
        {children}
      </div>
    </>
  );
};

export default EmptyData;
